/** Textos da secção "intro". Chaves planas "intro.*"; "pt" é a fonte, "en" a tradução. */
const pt = {
    "intro.loading": "A carregar",
};
const en = {
    "intro.loading": "Loading",
};

export default { pt, en };
